import { render } from "./PanelClienteSuscripciones.vue?vue&type=template&id=3e672fc0&scoped=true"
import script from "./PanelClienteSuscripciones.vue?vue&type=script&lang=js"
export * from "./PanelClienteSuscripciones.vue?vue&type=script&lang=js"

import "./PanelClienteSuscripciones.vue?vue&type=style&index=0&id=3e672fc0&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e672fc0"]])

export default __exports__